import { useTranslation } from 'react-i18next'
import { EmptyComponentContainer } from '#app/features/form/fields/emptyComponentContainer.tsx'
export const BigFiveIntroduction = () => {
	const { t } = useTranslation('ipipForm')

	return (
		<EmptyComponentContainer>
			<h1 className="mt-2 text-lg font-bold">{t('intro.title')}</h1>
			<br />
			<h3 className="text-md font-bold">{t('intro.welcome')}</h3>

			<p>{t('intro.intro')}</p>
			<br />
			<p>{t('intro.intro2')}</p>
			<br />
			<p>{t('intro.intro3')}</p>
			<br />
			<h3 className="text-md font-bold">{t('intro.intro4')}</h3>
			<p>{t('intro.intro5')}</p>
		</EmptyComponentContainer>
	)
}
